import React, { useEffect, useState } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { useTranslation } from 'react-i18next';

const PublicListingToggle = ({ coffeeShopId }) => {
  const { t } = useTranslation();
  const [currentStatus, setCurrentStatus] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStatus = async () => {
      const ref = doc(db, 'tenants', coffeeShopId);
      const snap = await getDoc(ref);
      if (snap.exists()) {
        setCurrentStatus(snap.data().public_listing || false);
      }
      setLoading(false);
    };
    if (coffeeShopId) fetchStatus();
  }, [coffeeShopId]);

  const toggleListing = async () => {
    const ref = doc(db, 'tenants', coffeeShopId);
    try {
      await setDoc(ref, { public_listing: !currentStatus }, { merge: true });
      setCurrentStatus(!currentStatus);
    } catch (err) {
      console.error('❌ Error toggling listing:', err);
    }
  };

  if (loading) return <p>{t('loading')}...</p>;

  return (
    <div style={{ marginTop: '10px' }}>
      <label>
        <strong>{t('public_listing.title')}</strong>
      </label>
      <br />
      <label>
        <input
          type="checkbox"
          checked={currentStatus}
          onChange={toggleListing}
          style={{ marginRight: '8px' }}
        />
        {currentStatus ? t('public_listing.visible') : t('public_listing.hidden')}
      </label>
    </div>
  );
};

export default PublicListingToggle;